export const sortDataObjectHeaders = (dataObjectHeaders, orderOfProperties) => {
    const sortedDataObjectHeaders = dataObjectHeaders.sort((a, b) => {
        let transformedA = (a ? a.split("_").pop() : a) || "";
        let transformedB = (a ? b.split("_").pop() : b) || "";
        // Find the index in orderOfProperties
        let indexA = orderOfProperties.indexOf(transformedA);
        let indexB = orderOfProperties.indexOf(transformedB);
        if (indexA === -1)
            indexA = Number.MAX_VALUE;
        if (indexB === -1)
            indexB = Number.MAX_VALUE;
        return indexA - indexB;
    });
    return sortedDataObjectHeaders;
};
